<template>
  <div class="recommend" v-if="isDayRecommendation">
    <div class="recommend-box">
      <div class="goods">
        <div class="goods-img" @click="goodsDetail()">
          <img :src="goods.logo">
        </div>
        <div class="goods-content" @click="goodsDetail()">
          <price :price="goods.price" :credit="goods.credit" :proposedPrice="goods.proposedPrice"></price>
          <div class="goods-name">{{goods.name}}</div>
          <div class="btn-box">
            <div class="btn">每日推荐</div>
          </div>
          <div class="bg"><img src="https://xcx.ihotel.cn/mall/images/daily-recommend-bg.png"></div>
        </div>
        <div class="close" @click="isDayRecommendation=false"><i class="iconfont iconshanchu1"></i></div>
      </div>
    </div>
  </div>
</template>
<script>
import { jAlert3, jAlert5 } from '@/base/jAlert/jAlert';
import { getStorage } from '@/utils/wxuser';
import price from '@/components/price';
import api from '@/utils/api';
var config = {};

export default {
  data() {
    return {
      isDayRecommendation: false,
      goods: [],
      user:{}
    };
  },
  methods: {
    goodsDetail() {
      this.$gc.track({
          behaviorType: 7,
          goodsId: this.goods.id,
          goodsName:this.goods.name
      });
      this.$router.push({
        path: '/goodsDetail',
        query: {
          id: this.goods.id,
          productType: 'normal',
        },
      });
    },
    DoOne(key) {
      var v = this.getCookie(key);
      if (!v) {
        this.getScrollPic()
        //获取第二天凌晨到当前时间的秒数
        var tim_sec =
          24 * 60 * 60 -
          (new Date().getHours() * 60 * 60 +
            new Date().getMinutes() * 60 +
            new Date().getSeconds());
        this.setCookie(this.$route.query.id, 1, tim_sec);
      }
    },
    setCookie(name, value, second) {
      if (!second) {
        second = 7 * 24 * 60 * 60; //默认7天
      }
      var exp = new Date();
      exp.setTime(exp.getTime() + second * 1000);
      document.cookie =
        name +
        '=' +
        encodeURI(value) +
        ';expires=' +
        exp.toGMTString() +
        ';path=/';
    },
    //读取cookies
    getCookie(name) {
      if (document.cookie.length > 0) {
        var c_start = document.cookie.indexOf(name + '='); //获取字符串的起点
        if (c_start != -1) {
          c_start = c_start + name.length + 1; //获取值的起点
          var c_end = document.cookie.indexOf(';', c_start); //获取结尾处
          if (c_end == -1) c_end = document.cookie.length; //如果是最后一个，结尾就是cookie字符串的结尾
          return decodeURI(document.cookie.substring(c_start, c_end)); //截取字符串返回
        }
      }
      return '';
    },
    getScrollPic() {
      let obj = {
        hotelGroupCode: config.hotelGroupCode,
        hotelCode: config.hotelCode,
        equipment: "desktop",
        aggregateId: this.$route.query.id,
        isOnLine: "T",
        appid:config.appid
      };

      api.listScrollPic(obj).then((res) => {
        if (res.result == 1) {
          if (res.retVal.length && res.retVal.length > 0) {
            var opt = {
              hotelGroupCode: config.hotelGroupCode,
              equipment: 'desktop',
              goodsId: res.retVal[0].link,
              appid: config.appid,
            };
             if (this.user && this.user.memberId) {
              this.getCurrentCard();
              var chuzhiIndex = getStorage("cardIndex") || 0;
              opt.cardLevel = this.user.cardListDto[chuzhiIndex].cardLevel;
            }
            api.goodsDetail(opt).then((res) => {
              if (res.result == 1) {
                this.isDayRecommendation = true;
                this.goods = res.retVal;
              }
            });
          }
        } else {
          jAlert3(res.msg);
        }
      });
    },
    // getScrollPic() {
    //   api
    //     .getScrollPic({
    //       hotelGroupCode: config.hotelGroupCode,
    //       location: 'day_recommendation',
    //       hotelCode: config.hotelCode,
    //     })
    //     .then((res) => {
    //       // console.log(res)
    //       if (res.result == 1) {
    //         if (res.retVal.link && res.retVal.link != '') {
    //           var opt = {
    //             hotelGroupCode: config.hotelGroupCode,
    //             equipment: 'desktop',
    //             goodsId: res.retVal.link,
    //             appid: config.appid,
    //           };
    //           api.goodsDetail(opt).then((res) => {
    //             if (res.result == 1) {
    //               this.isDayRecommendation = true;
    //               this.goods = res.retVal;
    //             }
    //           });
    //         }
    //       }
    //     });
    // },
  },
  created() {
    config = getStorage('config');
    this.user = getStorage('user');
  },
  mounted() {
    this.DoOne(this.$route.query.id);

  },
  components: {
    price,
  },
};
</script>
<style lang="less" scoped>
.recommend {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  .recommend-box {
    position: absolute;
    border-radius: 8px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .goods {
      width: 8rem;
      padding-bottom: 1.7rem;
      .goods-img {
        width: 100%;
        height: 5.333333rem;
        background: #fff;
        img {
          width: 100%;
          height: 100%;
          border-radius: 0.213333rem;
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
        }
      }
    }
    .goods-content {
      z-index: 2;
      border-bottom-left-radius: 0.213333rem;
      border-bottom-right-radius: 0.213333rem;
      padding: 0 0.4rem 0.2rem;
      position: relative;
      height: 3.946667rem;
      background: #fff;
      box-sizing: border-box;
      margin-top: -0.2rem;
      .goods-name {
        margin-top: 0.266667rem;
        font-size: 15px;
        color: #333333;
        line-height: 0.56rem;
        height: 1.12rem;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      .btn-box {
        display: flex;
        justify-content: center;
        .btn {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 0.426667rem;
          background-image: linear-gradient(0deg, #317fd1 0%, #73caff 100%);
          border-radius: 0.586667rem;
          height: 1.066667rem;
          font-size: 16px;
          color: #ffffff;
          width: 3.466667rem;
        }
      }
      .bg {
        z-index: -1;
        position: absolute;
        top: -1.12rem;
        left: -0.346667rem;
        img {
          width: 8.346667rem;
          height: 5.146667rem;
        }
      }
    }
    .close {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      .iconfont {
        color: #fff;
        font-size: 30px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/polymerization/recommend.vue